export const buffer = `
declare class Buffer {
  constructor(payload:string)            
  static from(payload:string):Buffer
  static concat(list:Buffer[]):Buffer
  
  from(payload:string):Buffer
  slice(start?:int, end?:int)
  
  readInt8(offset:number):number                        
  readUInt8(offset:number):number
  readUInt16BE(offset:number):number
  readUInt16LE(offset:number):number
  readInt16BE(offset:number):number
  readInt16LE(offset:number):number
  readUInt32BE(offset:number):number
  readUInt32LE(offset:number):number
  readInt32BE(offset:number):number
  readInt32LE(offset:number):number
  readUIntBE(offset:number, byteLength:number)
  readUIntLE(offset:number, byteLength:number)
  readIntBE(offset:number, byteLength:number)
  readIntLE(offset:number, byteLength:number)
  readFloatBE(offset:number):number
  readFloatLE(offset:number):number
  readDoubleBE(offset:number):number
  readDoubleLE(offset:number):number
  length:number;
}`;